import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import { Link, Redirect } from "react-router-dom";
import {
  Alert,
  TextInput,
  Button,
  SelectOption,
  Form,
  FormGroup,
  ActionGroup,
} from "@patternfly/react-core";
import { Spinner } from '@patternfly/react-core';
import {
  REQUESTED_USERS,
  REQUESTED_CREATE_USER,
  REQUESTED_UPDATE_USER,
  REQUESTED_CLEAR_FAILED_MSG,
} from "../../redux/actions/userAction";
import { REQUESTED_PRODUCTS } from "../../redux/actions/productAction";
// import { REQUESTED_ACTIVITIES } from "../../redux/actions/activityAction";
import SingleSelectInput from "../general/SingleSelect";
import MultiTypeaheadSelectInput from "../general/MultipleSelect";

export default (props) => {
  const mapState = useCallback(
    (state) => ({
      productsMap: state.productState.productsMap,
      isCreatingUser: state.userState.isCreatingUser,
      isCreatedUser: state.userState.isCreatedUser,
      isUpdatingUsers: state.userState.isUpdatingUsers,
      isUpdatedUsers: state.userState.isUpdatedUsers,
      fetchingCreateUserError: state.userState.fetchingCreateUserError,
      fetchingUpdateUserError: state.userState.fetchingUpdateUserError,
    }),
    []
  );

  const {
    productsMap,
    isCreatingUser,
    isCreatedUser,
    isUpdatingUsers,
    isUpdatedUsers,
    fetchingCreateUserError,
    fetchingUpdateUserError,
  } = useMappedState(mapState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!productsMap) {
      dispatch({
        type: REQUESTED_PRODUCTS,
        payload: {},
      });
    }
  }, [dispatch, productsMap]);

  const [userKerberos, setUserKerberos] = useState(
    props.user ? props.user.kerberos : ""
  );
  const [userEmail, setUserEmail] = useState(
    props.user ? props.user.email : ""
  );
  const [userFirstName, setUserFirstName] = useState(
    props.user ? props.user.first_name : ""
  );
  const [userLastName, setUserLastName] = useState(
    props.user ? props.user.last_name : ""
  );
  const [editRole, setEditRole] = useState(props.user ? props.user.role : "");
  const [editProducts, setEditProducts] = useState();
  const [userUpserted, setUserUpserted] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  let selectedProducts = [];
  if (props.user && "None" !== props.user.user_products) {
    props.user.products &&
      props.user.products.forEach((product) => {
        selectedProducts.push(product.name);
      });
  }

  const productSelectOptions = productsMap
    ? Object.keys(productsMap).map((key) => (
        <SelectOption
          key={`product-${productsMap[key].id}`}
          value={productsMap[key].name}
        />
      ))
    : [<SelectOption key={`default`} value={""} />];

  const roleOptions = [
    { value: "Select a role", disabled: true },
    { value: "admin", disabled: false },
    { value: "product_manage", disabled: false },
    { value: "product_edit", disabled: false },
  ];

  const roleSelectOptions = roleOptions.map((option, index) => (
    <SelectOption
      isDisabled={option.disabled}
      key={`role-${index}`}
      value={option.value}
    />
  ));

  function onSubmit() {
    if (props.user) {
      //console.log('---------updating-a-user---------');
      let updateuser = {
        id: props.user.id,
        user: {},
      };
      if (userEmail && userEmail !== props.user.email) {
        updateuser.user.email = userEmail === "" ? null : userEmail;
      }
      if (userFirstName && userFirstName !== props.user.first_name) {
        updateuser.user.first_name =
          userFirstName === "" ? null : userFirstName;
      }
      if (userLastName && userLastName !== props.user.last_name) {
        updateuser.user.last_name = userLastName === "" ? null : userLastName;
      }

      if (editProducts) {
        let add_products = [];
        let delete_products = [];
        editProducts.forEach((editproduct) => {
          if (!selectedProducts.includes(editproduct)) {
            add_products.push(editproduct);
          }
        });

        selectedProducts.forEach((selectproduct) => {
          if (!editProducts.includes(selectproduct)) {
            delete_products.push(selectproduct);
          }
        });
        if (add_products && add_products.length !== 0) {
          updateuser.user.add_products = add_products;
        }
        if (delete_products && delete_products.length !== 0) {
          updateuser.user.delete_products = delete_products;
        }
      }

      if (editRole && editRole !== props.user.role) {
        if ("admin" === editRole) {
          if (!props.user.manage_user) {
            updateuser.user.manage_user = "Add";
          }
          if (!props.user.manage_product) {
            updateuser.user.manage_product = "Add";
          }
        } else if ("product_manage" === editRole) {
          if (props.user.manage_user) {
            updateuser.user.manage_user = "Remove";
          }
          if (!props.user.manage_product) {
            updateuser.user.manage_product = "Add";
          }
        } else {
          if (props.user.manage_user) {
            updateuser.user.manage_user = "Remove";
          }
          if (props.user.manage_product) {
            updateuser.user.manage_product = "Remove";
          }
        }
      }
      //console.log(updateuser);

      dispatch({
        type: REQUESTED_UPDATE_USER,
        payload: { user: updateuser },
      });
    } else {
      //console.log('---------creating-a-user---------');
      let createuser = {
        kerberos: userKerberos,
        first_name: userFirstName,
        last_name: userLastName,
        email: userEmail,
      };

      if (editProducts && editProducts.length !== 0) {
        createuser = { ...createuser, add_products: editProducts };
      }
      if ("admin" === editRole) {
        createuser = {
          ...createuser,
          manage_user: "Add",
          manage_product: "Add",
        };
      } else if ("product_manage" === editRole) {
        createuser = { ...createuser, manage_product: "Add" };
      }
      //console.log(createuser);

      if (!editRole || "" === editRole) {
        setErrorMsg("User role cannot be empty");
      } else {
        dispatch({
          type: REQUESTED_CREATE_USER,
          payload: { user: createuser },
        });
      }
    }
  }

  function composeErrorMsg(err) {
    let errMsg = err.message;
    if (err.details && err.details.length > 0) {
      errMsg += ": ";
      err.details.forEach((detail) => {
        errMsg += detail.message + ". ";
      });
    }
    return errMsg;
  }

  useEffect(() => {
    if (fetchingCreateUserError) {
      setErrorMsg(composeErrorMsg(fetchingCreateUserError));
    }
  }, [dispatch, fetchingCreateUserError]);

  useEffect(() => {
    if (fetchingUpdateUserError) {
      setErrorMsg(composeErrorMsg(fetchingUpdateUserError));
    }
  }, [dispatch, fetchingUpdateUserError]);

  function renderErrorMsg() {
    if (errorMsg !== "") {
      return <Alert variant="danger" title={`${errorMsg}`} />;
    }
  }

  function renderButtons() {
    if ((isCreatingUser || isUpdatingUsers) && !fetchingCreateUserError) {
      return <Spinner size="xl" />;
    }
    return (
      <>
        <Button
          variant="primary"
          disabled={isCreatingUser || isUpdatingUsers}
          onClick={() => onSubmit()}
        >
          {`Save`}
        </Button>
        <Link to="/user/list">
          <Button
            variant="tertiary"
            disabled={isCreatingUser || isUpdatingUsers}
          >{`Cancel`}</Button>
        </Link>
      </>
    );
  }

  useEffect(() => {
    if (isCreatedUser || isUpdatedUsers) {
      dispatch({
        type: REQUESTED_USERS,
        payload: {},
      });
      setUserUpserted(true);
      // dispatch({
      //   type: REQUESTED_ACTIVITIES,
      //   payload: {},
      // });
    }
  }, [dispatch, isCreatedUser, isUpdatedUsers]);

  function onSelectProduct(selected) {
    setEditProducts(selected);
  }

  function onSelectRole(selection) {
    setEditRole(selection);
  }

  // clean up
  useEffect(() => {
    // Specify how to clean up after this effect:
    return function cleanup() {
      dispatch({
        type: REQUESTED_CLEAR_FAILED_MSG,
        payload: {},
      });
    };
  });

  return (
    <>
      {userUpserted ? <Redirect to="/user/list" /> : null}
      <Form>
        <FormGroup
          label="Kerberos ID"
          isRequired
          fieldId="user-create-form-kerberos"
        >
          <TextInput
            value={userKerberos}
            isRequired
            isReadOnly={props.user ? true : false}
            type="text"
            id="user-create-form-kerberos"
            aria-describedby="user-create-form-kerberos-helper"
            name="user-create-form-kerberos"
            onChange={(value) => {
              setUserKerberos(value);
            }}
          />
        </FormGroup>
        <FormGroup
          label="First Name"
          isRequired
          fieldId="user-create-form-firstname"
        >
          <TextInput
            value={userFirstName}
            isRequired
            type="text"
            id="user-create-form-firstname"
            aria-describedby="user-create-form-firstname-helper"
            name="user-create-form-firstname"
            onChange={(value) => {
              setUserFirstName(value);
            }}
          />
        </FormGroup>
        <FormGroup
          label="Last Name"
          isRequired
          fieldId="user-create-form-lastname"
        >
          <TextInput
            value={userLastName}
            isRequired
            type="text"
            id="user-create-form-lastname"
            aria-describedby="user-create-form-lastname-helper"
            name="user-create-form-lastname"
            onChange={(value) => {
              setUserLastName(value);
            }}
          />
        </FormGroup>
        <FormGroup label="Email" isRequired fieldId="user-create-form-email">
          <TextInput
            value={userEmail}
            isRequired
            type="text"
            id="user-create-form-email"
            aria-describedby="user-create-form-email-helper"
            name="user-create-form-email"
            onChange={(value) => {
              setUserEmail(value);
            }}
          />
        </FormGroup>
        <FormGroup label="Edit Product" fieldId="user-create-form-products">
          <MultiTypeaheadSelectInput
            titleId="edit-product-multi-select"
            placeholder="Select product"
            options={productSelectOptions}
            selected={selectedProducts}
            onSelect={(selected) => onSelectProduct(selected)}
          />
        </FormGroup>
        <FormGroup
          label="Set Role"
          isRequired
          fieldId="user-create-form-add-role"
        >
          <SingleSelectInput
            titleId="user-create-form-add-role"
            options={roleSelectOptions}
            selected={editRole}
            onSelect={(selection) => onSelectRole(selection)}
          />
        </FormGroup>
        {renderErrorMsg()}
        <ActionGroup>{renderButtons()}</ActionGroup>
      </Form>
    </>
  );
};
